import React, { useEffect, useState } from 'react';
import useApiCallHooks from '../../../hooks/useApiCallHooks';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import OverlayLoader from '../../../components/Common/OverlayLoader';

const OtgForm = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();

  
  const [formData, setFormData] = useState({
  first_name: '',
  last_name: '',
  email: '',
  mobile_no: '',
  description: '',
  type: 'OJT'
});



  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    callAPI('post', 'add-contact-us', formData);
  };

  // Handle response
  useEffect(() => {
    if (responce?.data && statusCode === 200) {
      toast.success('Your message has been sent successfully!');
   
    }

    if (responce?.data && statusCode === 201) {
      toast.success('Contact created successfully!');
      setTimeout(() => {
        navigate('/');
      }, 1500);
    }

  }, [responce, statusCode, error, navigate]);

  return (
    
    <div className="container py-5">
      <OverlayLoader show={loading} />

      <div className="row">
        {/* Left Column: Info */}
   <div className="col-md-6 mb-4">
  <div className="p-4 shadow rounded bg-light h-100 d-flex flex-column justify-content-between">
    <div>
      <h2 className="text-primary fw-bold text-center mb-3">Join Our OJT Program</h2>
      <p className="text-muted">
        Our On-Job Training (OJT) program is designed to bridge the gap between academic knowledge and industry requirements.
        You'll gain practical exposure, build real-world applications, and work under expert mentorship.
      </p>

      <ul className="list-group list-group-flush mt-3 mb-4">
        <li className="list-group-item border-0 ps-0">✅ Work on Live Real-time Projects</li>
        <li className="list-group-item border-0 ps-0">✅ Resume Building with Portfolio Guidance</li>
        <li className="list-group-item border-0 ps-0">✅ Certification on Completion & Internship Letter</li>
        <li className="list-group-item border-0 ps-0">✅ Improve Problem Solving & Communication Skills</li>
        <li className="list-group-item border-0 ps-0">✅ Learn Git, GitHub, Agile Practices, and Deployment</li>
        <li className="list-group-item border-0 ps-0">✅ Flexible Timings & Remote Participation Options</li>
      </ul>

     
    </div>
  </div>
</div>



        {/* Right Column: Form */}
        <div className="col-md-6">
          <div className="card shadow p-4 rounded">
            <h4 className="text-center text-primary mb-4">OJT Registration Form</h4>
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* First Name */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    placeholder="Enter first name"
                    
                  />
                  <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.first_name}
                </span>
                </div>

                {/* Last Name */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    placeholder="Enter last name"
                    
                  />
                         <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.last_name}
                </span>
                </div>

                {/* Email */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter email"
                    
                  />
                         <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.email}
                </span>
                </div>

                {/* Mobile */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Mobile No</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="mobile_no"
                    value={formData.mobile_no}
                    onChange={handleChange}
                    placeholder="Enter mobile number"
                  />
                         <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.mobile_no}
                </span>
                </div>

                {/* Description */}
                <div className="col-md-12 mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    name="description"
                    rows="3"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Write a brief description"
                    
                  ></textarea>
                          <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.description}
                </span>
                </div>

                {/* Type */}
                <div className="col-md-6 mb-3">
                  <input
                    type="hidden"
                    className="form-control"
                    name="type"
                    value={formData.type}
                    readOnly
                  />
                   
                </div>
              </div>

              {/* Submit Button */}
              <div className="text-center mt-3">
                <button type="submit" className="btn btn-primary px-5">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtgForm;
